module.exports = __webpack_public_path__ + "img/project-3.6839bf22.jpg";